<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-12 col-lg">
          <h3 class="card-header-title">Start of Placement Plan</h3>
        </div>
        <div class="col-6 col-lg-auto text-lg-right">
          <span class="minor">
            <span class="strong">Open Date:</span>
            {{ placement.start_component_open_date | date }}
          </span>
        </div>
        <div class="col-6 col-lg-auto text-lg-right">
          <span class="minor">
            <span class="strong">Due Date:</span>
            {{ placement.start_component_due_date | date }}
          </span>
        </div>
      </div><!-- /.row -->
    </div>

    <ul class="list-data no-links no-hover">
      <li>
        <div class="row align-items-center">
          <div class="col">
            <p>Graduate Plan</p>
          </div>

          <!-- Graduate Plan Statuses for Graduate -->
          <div class="col-auto" v-if="$userIsGraduate">
            <span
              class="status status-default"
              v-if="placementStartComponentIsContextuallyNotOpen"
            >Not Open</span>
            <span
              class="status status-default"
              v-else-if="placementStartComponentIsPendingData"
            >Pending Graduate Entry</span>
            <span
              class="status status-default"
              v-else-if="placementStartComponentIsDraft"
            >Draft</span>
            <span
              class="status status-info"
              v-else-if="placementStartComponentIsPendingReview"
            >Pending Review</span>
            <span
              class="status status-success"
              v-else-if="placementStartComponentIsSignedOff"
            >Signed Off</span>
          </div>

          <!-- Graduate Plan Statuses for Everyone Else -->
          <div class="col-auto" v-else>
            <span
              class="status status-default"
              v-if="placementStartComponentIsContextuallyNotOpen"
            >Not Open</span>
            <span
              class="status status-default"
              v-else-if="placementStartComponentIsPendingData"
            >Pending Graduate Entry</span>
            <span
              class="status status-default"
              v-else-if="placementStartComponentIsDraft"
            >Draft</span>
            <span
              class="status status-info"
              v-else-if="placementStartComponentIsPendingReview"
            >Pending Review</span>
            <span
              class="status status-success"
              v-else-if="placementStartComponentIsSignedOff"
            >Signed Off</span>
          </div>
        </div>
      </li>
      <li>
        <div class="row align-items-center">
          <div class="col">
            <p>Manager Approval</p>
          </div>

          <!-- Manager Approval Statuses for Graduate -->
          <div class="col-auto" v-if="$userIsGraduate">
            <span
              class="status status-default"
              v-if="placementStartComponentIsContextuallyNotOpen"
            >Not Open</span>
            <span
              class="status status-default"
              v-else-if="placementStartComponentIsPendingData"
            >Pending Graduate Entry</span>
            <span
              class="status status-default"
              v-else-if="placementStartComponentIsDraft"
            >Draft</span>
            <span
              class="status status-info"
              v-else-if="placementStartComponentIsPendingReview"
            >Pending Review</span>
            <span
              class="status status-success"
              v-else-if="placementStartComponentIsSignedOff"
            >Signed Off</span>
          </div>

          <!-- Manager Approval Statuses for Everyone Else -->
          <div class="col-auto" v-else>
            <span
              class="status status-default"
              v-if="placementStartComponentIsContextuallyNotOpen"
            >Not Open</span>
            <span
              class="status status-default"
              v-else-if="placementStartComponentIsPendingData"
            >Pending Graduate Entry</span>
            <span
              class="status status-default"
              v-else-if="placementStartComponentIsDraft"
            >Draft</span>
            <span
              class="status status-info"
              v-else-if="placementStartComponentIsPendingReview"
            >Pending Review</span>
            <span
              class="status status-success"
              v-else-if="placementStartComponentIsSignedOff"
            >Signed Off</span>
          </div>
        </div>
      </li>
    </ul><!-- /.list-data -->

    <div class="card-footer text-right" v-if="$userIsGraduate && graduateCanViewButtons">
      <router-link
        v-if="!placementStartComponentIsPendingData && !placementStartComponentIsDraft"
        class="btn btn-sm btn-success"
        :to="{ name: 'placements.single.start.review', params: { placementId: placement.id, graduateId: graduate.id } }"
      >View</router-link>
      <a v-else href="" @click.prevent="navigateToComponent" class="btn btn-sm btn-success">
          Continue
      </a>
    </div>

    <div class="card-footer text-right" v-if="$userIsAdmin && adminCanViewButtons">
      <router-link
        class="btn btn-sm btn-success"
        :to="{ name: 'placements.single.start.admin.performance', params: { placementId: placement.id, graduateId: graduate.id } }"
      >Continue as graduate</router-link>
    </div>

    <div class="card-footer text-right" v-else-if="($userIsManager || $userIsCoordinator) && !placementStartComponentIsPendingData && !placementStartComponentIsDraft">
      <router-link
        class="btn btn-sm btn-success"
        :to="{ name: 'placements.single.start.manager.review', params: { placementId: placement.id, graduateId: graduate.id } }"
      >View</router-link>
    </div>
  </div><!-- /.card -->
</template>

<script>
import { placementComputed, graduateComputed } from 'vx/helpers'
import { helpers } from 'mixins/placements'
import { alert } from 'utils'

export default {
  mixins: [helpers],

  computed: {
    ...placementComputed,
    ...graduateComputed,

    graduateCanViewButtons () {
      return this.placementStartComponentIsOpen &&
        this.placement.agency_id !== null &&
        !this.placementEndComponentIsSignedOff
    },

    adminCanViewButtons () {
      return this.placementStartComponentIsOpen &&
        this.placement.agency_id !== null &&
        this.placement.manager_id !== null &&
        !this.placementEndComponentIsSignedOff &&
        (
          this.placementStartComponentIsPendingData ||
          this.placementStartComponentIsDraft
        )
    }
  },

  methods: {
    navigateToComponent () {
      if (this.$userIsGraduate && this.placement.manager_id === null) {
        alert.warning({
          title: 'Manager Not Assigned',
          text: 'Your placement manager must be assigned on-system before you can commence creating your PDP. \n Ensure you have discussed and defined your objectives together with your manager before beginning. \n \n Please speak with your Agency Coordinator to assign your manager.'
        })
      } else {
        this.$router.push({ name: 'placements.single.start.performance', params: { placementId: this.placement.id } })
      }
    }
  }
}
</script>

<style>
  .swal-text {
    text-align : center !important;
  }
</style>
